import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import Loader from '../../../loader/Loader'
import Text from '../../../input_filed/Text'
import SelectStatus from '../../../input_filed/SelectStatus'
import SaveButton from '../../../buttons/SaveButton'
import { ToastContainer, toast } from 'react-toastify'
import { useFormik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { ModalSchema } from './Validation'
import { UpdateModelRes, UpdateModelTodo } from '../../../../redux/slices/master_slice/vehical modal/UpdateModal'
import SingleSelect from '../../../input_filed/SingleSelect'
import { BrandListRes, BrandListTodo } from '../../../../redux/slices/master_slice/vehical_brand/BrandList'

export default function UpdateModelForm() {
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const { state } = useLocation()
    const id = state?.id
    const dispatch = useDispatch()
    const brandList = useSelector(state => state?.BrandList?.data?.data)

    const brand_option = brandList && brandList.map(val => (
        { "value": val.id, "label": val.vehicle_brand_name }
    ))
  
    useEffect(() => {
        setLoading(true)
        dispatch(BrandListTodo()).then(() => brand_res())
    }, [])

    const brand_res=()=>{
        if (BrandListRes?.sucess) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    const initialValues = {
        brand : state?.VehicleBrandSchema?.id,
        model: state?.vehicle_model_name,
        status: state?.vehicle_model_status
    }

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: ModalSchema,

        onSubmit: (values, action) => {
            setLoading(true)
            dispatch(UpdateModelTodo({ values,id })).then(() => update_res(action))
        }
    })

    const update_res = () => {
        if (UpdateModelRes?.success) {
            toast.success(UpdateModelRes?.message, { position: "bottom-right" });
            setLoading(false)
            setTimeout(() => {
                navigate('/model')
            }, 1500);
        } else {
            setLoading(false)
            toast.error(UpdateModelRes?.message, { position: "bottom-right" });
        }
    }

    return (
        <>
            <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                <div className='form_layout mt-3'>
                    {loading ?
                        <div className='d-flex justify-content-center p-5'>
                            <Loader />
                        </div> :
                        <div className='row'>
                             <div className='col-md-4 mb-3'>
                                <SingleSelect
                                    closeMenu={true}
                                    label_name='Brand'
                                    option={brand_option ? brand_option : []}
                                    disabled={false}
                                    name='brand'
                                    defaultValue={brand_option && brand_option.find((option) => option.value == values.brand)}
                                    onChange={(e) =>
                                        setFieldValue('brand', e.value)
                                    }
                                    onBlur={handleBlur}
                                    error={errors.brand && touched.brand ? (<span className='text-danger form_label' >{errors.brand}</span>) : null}
                                />
                            </div>
                            <div className='col-md-4'>
                                <Text
                                    label_name='Model'
                                    placeholder=''
                                    name='model'
                                    value={values.model || ''}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.model && touched.model ? (<span className='text-danger form_label' >{errors.model}</span>) : null}
                                />
                            </div>

                            <div className='col-md-4'>
                                <SelectStatus
                                    closeMenu={true}
                                    label_name='Status'
                                    disabled={false}
                                    name='status'
                                    defaultValue={values.status}
                                    onChange={(e) =>
                                        setFieldValue('status', e.value)
                                    }
                                    onBlur={handleBlur}
                                    error={errors.status && touched.status ? (<span className='text-danger form_label' >{errors.status}</span>) : null}
                                />
                            </div>
                            <div className='col-md-12 text-end mt-2'>
                                <SaveButton name={'Update'} />
                            </div>
                        </div>}
                </div>
            </Form>
            <ToastContainer/>
        </>
    )
}
